import React, { useState } from 'react';
import { useEditor } from '@mnz/builder';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';
import NewBlockCard from './NewBlockCard';
import { MORE_BLOCKS, RECOMMEND_BLOCKS } from '../../../../constants';
import AddCustomLinkModal from './AddCustomLinkModal';
import { CustomLinkValues } from '@mnz/element/build/basic/custom-link/EditCustomLink';

interface BlockModalProps extends DialogProps {
    setModal: (modal: string | null) => void;
    setOpenModalComingSoon: () => void;
}
const AddBlockModal: React.FC<BlockModalProps> = ({ setModal, ...props }) => {
    const {
        actions: { add: addNode, selectNode },
        nodes,
        query,
        designSettings,
        account,
    } = useEditor((_, query) => {
        const nodes = query.getNodes();
        return {
            nodes,
        };
    });
    const [openModalAddCustomLink, setOpenModalAddCustomLink] = useState(false);
    const handleAddNewCustomLink = async (link: CustomLinkValues) => {
        const baseCustomLinkNodeData = MORE_BLOCKS.find((block) => block.name === 'CustomLink')?.nodeData;
        if (baseCustomLinkNodeData) {
            const newNodeData = {
                ...baseCustomLinkNodeData,
                props: {
                    text: link.text,
                    link: link.link,
                },
            };
            const node = query.parseSerializedNode(newNodeData, designSettings, account).toNode();
            addNode(node, 'ROOT', nodes.ROOT.data.nodes.length);
            setOpenModalAddCustomLink(false);
            setModal(null);
        }
    };
    return (
        <>
            <Dialog {...props}>
                <div className="mt-20 px-24 pb-50">
                    <div className="text-12 font-bold border-b border-primary-40 pb-6">RECOMMENDED</div>
                    <div className="mt-12 flex flex-col space-y-8">
                        {RECOMMEND_BLOCKS.map((block, idx) => (
                            <NewBlockCard
                                key={idx}
                                title={block.title}
                                subTitle={block.subTitle}
                                image={block.image}
                                icon={block.icon}
                                forGrowAccount={block.forGrowAccount}
                                isReady={block.isReady}
                                reachLimits={block.limits > 0 && query.getNumberOfNodeType(block.name) === block.limits}
                                onClickAdd={() => {
                                    const canAdd =
                                        block.limits === 0 || query.getNumberOfNodeType(block.name) < block.limits;
                                    if (block.isReady) {
                                        if (canAdd) {
                                            const node = query
                                                .parseSerializedNode(block.nodeData, designSettings, account)
                                                .toNode();
                                            addNode(node, 'ROOT', nodes.ROOT.data.nodes.length);
                                            selectNode(node.id);
                                            setModal(null);
                                        }
                                    }
                                }}
                            />
                        ))}
                    </div>
                    <div className="mt-36 text-12 font-bold border-b border-primary-40 pb-6">MORE</div>
                    <div className="mt-12 flex flex-col space-y-8">
                        {MORE_BLOCKS.map((block, idx) => (
                            <NewBlockCard
                                key={idx}
                                title={block.title}
                                subTitle={block.subTitle}
                                image={block.image}
                                icon={block.icon}
                                forGrowAccount={block.forGrowAccount}
                                isReady={block.isReady}
                                reachLimits={block.limits > 0 && query.getNumberOfNodeType(block.name) === block.limits}
                                onClickAdd={() => {
                                    const canAdd =
                                        block.limits === 0 || query.getNumberOfNodeType(block.name) < block.limits;
                                    if (block.isReady) {
                                        if (canAdd) {
                                            if (block.name === 'CustomLink') {
                                                setOpenModalAddCustomLink(true);
                                                setModal(null);
                                            } else {
                                                const node = query
                                                    .parseSerializedNode(block.nodeData, designSettings, account)
                                                    .toNode();
                                                addNode(node, 'ROOT', nodes.ROOT.data.nodes.length);
                                                selectNode(node.id);
                                                setModal(null);
                                            }
                                        }
                                    }
                                }}
                            />
                        ))}
                    </div>
                </div>
            </Dialog>
            <AddCustomLinkModal
                title="Custom Link"
                open={openModalAddCustomLink}
                onClose={() => setOpenModalAddCustomLink(false)}
                setOpenModalAddCustomLink={setOpenModalAddCustomLink}
                onSubmitCustomLink={handleAddNewCustomLink}
            />
        </>
    );
};

export default AddBlockModal;
